import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import Product2skill2exp2rateFilterCriteria from './Product2skill2exp2rateFilterCriteria'
import Product2skill2exp2rateList from './Product2skill2exp2rateList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './Product2skill2exp2rateAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setProduct2skill2exp2rateDashboardProduct2skill2exp2rateList } from '../../store/slice/ManufSlice';

export default function Product2skill2exp2rateListView({setShowEdit,setProduct2skill2exp2rateId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.product2skill2exp2rateDashboard);   

    const [filteredProduct2skill2exp2rateList, setFilteredProduct2skill2exp2rateList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { product2skill2exp2rateDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (product2skill2exp2rateDashboard.product2skill2exp2rateList.length>-1){
        setFilteredProduct2skill2exp2rateList(product2skill2exp2rateDashboard.product2skill2exp2rateList);
        transformToCardFormat(product2skill2exp2rateDashboard.product2skill2exp2rateList, setCardList);
      }
    },[product2skill2exp2rateDashboard.product2skill2exp2rateList])

    useEffect(()=>{
          transformToCardFormat(filteredProduct2skill2exp2rateList, setCardList);
      },[filteredProduct2skill2exp2rateList])

    useEffect(()=>{
        if (filterCriteria.skillid==='' && filterCriteria.skillname==='' && filterCriteria.experiencelevelid==='' && filterCriteria.productid==='' && filterCriteria.productname==='' && filterCriteria.rate==='' && filterCriteria.workerid==='' && filterCriteria.workername==='' && filterCriteria.typeid==='' ){
            setFilteredProduct2skill2exp2rateList(product2skill2exp2rateDashboard.product2skill2exp2rateList);
            transformToCardFormat(product2skill2exp2rateDashboard.product2skill2exp2rateList, setCardList);

        } else {
            setFilteredProduct2skill2exp2rateList(
                product2skill2exp2rateDashboard.product2skill2exp2rateList
                    .filter(product2skill2exp2rate=> product2skill2exp2rate.skillname.toString().toUpperCase().includes(filterCriteria.skillname.toString().toUpperCase()))
.filter(product2skill2exp2rate=> product2skill2exp2rate.productname.toString().toUpperCase().includes(filterCriteria.productname.toString().toUpperCase()))
.filter(product2skill2exp2rate=> product2skill2exp2rate.workername.toString().toUpperCase().includes(filterCriteria.workername.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(product2skill2exp2rateDashboard.filteredProduct2skill2exp2rateList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <Product2skill2exp2rateList
                    setShowEdit={setShowEdit}
                    setProduct2skill2exp2rateId = {setProduct2skill2exp2rateId}
                    tableList={filteredProduct2skill2exp2rateList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}